import { fromBase64URL, toBase64URL } from "../bytes";
import { generateClientKey } from "./crypto";

/** 每台主机（每个身份）一把手机端 X25519 私钥（配对时生成，主机只记公钥）。 */
export interface RelayKeyStore {
  clientKey(account: string): Uint8Array;
  removeKey(account: string): void;
}

/**
 * 存在浏览器本地（localStorage）。网页没有钥匙串，这是浏览器里能做到的最好程度：
 * 只有同一个网站能读，不会发给任何服务器。
 */
export class LocalRelayKeyStore implements RelayKeyStore {
  constructor(private readonly prefix = "timibot.relayKey.") {}

  clientKey(account: string): Uint8Array {
    const key = this.prefix + account;
    try {
      const saved = localStorage.getItem(key);
      const bytes = saved ? fromBase64URL(saved) : undefined;
      if (bytes && bytes.length === 32) return bytes;
    } catch { /* 读不到就生成新的 */ }
    const fresh = generateClientKey();
    try { localStorage.setItem(key, toBase64URL(fresh)); } catch { /* 私密模式：只在这次会话里有效 */ }
    return fresh;
  }

  removeKey(account: string): void {
    try { localStorage.removeItem(this.prefix + account); } catch { /* 忽略 */ }
  }
}

export class MemoryRelayKeyStore implements RelayKeyStore {
  private keys = new Map<string, Uint8Array>();

  clientKey(account: string): Uint8Array {
    let k = this.keys.get(account);
    if (!k) { k = generateClientKey(); this.keys.set(account, k); }
    return k;
  }

  removeKey(account: string): void { this.keys.delete(account); }
}
